import dynamic from "next/dynamic";

import { useState } from "react";

import { twMerge } from "tailwind-merge";

import { faChevronDown } from "@fortawesome/free-solid-svg-icons/faChevronDown";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons/faChevronUp";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useMediaQuery from "hooks/useMediaQuery";

const PresetsModal = dynamic(() => import("components/PresetsModal"));

type PresetsButtonProps = {
  className?: string;
  onApply?: (_preset: any) => void;
};

const PresetsButton = ({ className, onApply }: PresetsButtonProps) => {
  const [showModal, toggleModal] = useState(false);
  const { mobile } = useMediaQuery();

  if (mobile) {
    return (
      <>
        <button
          className={twMerge(
            "border-none text-smart-teal hover:text-dark-teal min-w-[100px] bg-transparent",
            className
          )}
          onClick={() => toggleModal(true)}
        >
          My Presets
          <FontAwesomeIcon
            className="text-[11px] ml-[4px]"
            icon={showModal ? faChevronUp : faChevronDown}
          />
        </button>
        {showModal && (
          <PresetsModal
            onClose={() => toggleModal(false)}
            onApply={(preset) => {
              toggleModal(false);
              onApply?.(preset);
            }}
          />
        )}
      </>
    );
  }

  return (
    <>
      <button
        className={twMerge(
          "border-none text-smart-teal hover:text-dark-teal min-w-[100px] bg-transparent",
          className
        )}
        onClick={() => toggleModal(true)}
      >
        My Presets
      </button>
      {showModal && (
        <PresetsModal
          onClose={() => toggleModal(false)}
          onApply={(preset) => {
            toggleModal(false);
            onApply?.(preset);
          }}
        />
      )}
    </>
  );
};

export default PresetsButton;
